import type {ReactElement} from 'react';
import React from 'react';
import {BaseGlowOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-glow-option';
import type {AuraType} from '@PosterWhiteboard/classes/item-aura.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromAuraOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromAuraOfActiveSlideItem';

interface SlideshowItemGlowOptionProps {
  onClickColorFill(): void;
}

export function SlideshowItemGlowOption({...props}: SlideshowItemGlowOptionProps): ReactElement {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const glowColor = useGetKeyFromAuraOfActiveSlideItem('glowColor');
  const auraType = useGetKeyFromAuraOfActiveSlideItem('type');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected slide');
  }

  if (!glowColor || auraType === undefined) {
    throw new Error('unable to get aura properties for selected slide');
  }

  const onClickHandler = (type: AuraType): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      aura: {
        type: Number(type),
      },
    });
  };

  return (
    <BaseGlowOption
      glowColor={glowColor}
      auraType={auraType}
      onApplyGlow={onClickHandler}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
